import React from 'react';

/**
 * Optional parameters for an icon
 * @typedef {object} GlyphIconProps
 * @property {string} d Composite path
 * @property {string} [viewBox] Defaults to "0 0 32 32"
 * @property {string} [fill] Defaults to "currentColor"
 * @property {string} [stroke] Defaults to "none"
 * @property {HTMLStyleElement} [style] Defaults to {}
 * @property {string} [className]
 */

/**
 * SVG icon object as React.Component
 * @typedef GlyphIcon
 * @param {GlyphIconProps} props
 * @returns {SVGElement}
 */
const GlyphIcon = class extends React.Component {
	render() {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox={ this.props.viewBox ?? "0 0 32 32" }
				fill={ this.props.fill ?? "currentColor" }
				stroke={ this.props.stroke ?? "none" }
				style={{...this.props.style}}
				className={ this.props.className }
			>
				<path d={this.props.d}/>
			</svg>
		);
	}
}

export default GlyphIcon;